import { HTMLAttributes } from "react"

export default function FastSpring(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8745 11.5537L30.5022 2L31.5309 3.46667C33.5272 6.31852 32.8346 10.2398 29.993 12.2361L16.355 21.8L15.3263 20.3333C13.33 17.4815 14.0226 13.5602 16.8745 11.5537Z"
        fill="url(#paint0_linear_2483_1780)"
      />
      <path
        d="M16.9457 23.6639L30.5837 14.1L31.6124 15.5667C33.6087 18.4185 32.9161 22.3398 30.0744 24.3361L16.4263 33.9L15.3976 32.4333C13.4013 29.5815 14.0939 25.6602 16.9457 23.6639Z"
        fill="url(#paint1_linear_2483_1780)"
      />
      <path
        d="M17.0171 35.7639L30.655 26.2102L31.6837 27.6769C33.68 30.5287 32.9874 34.45 30.1458 36.4463L16.5078 46L15.4791 44.5333C13.4828 41.6917 14.1652 37.7602 17.0171 35.7639Z"
        fill="url(#paint2_linear_2483_1780)"
      />
      <path
        d="M23.6374 23.3889C21.5291 26.1185 19.8384 29.1537 18.606 32.3722L30.0643 24.3361C32.9161 22.3398 33.6087 18.4083 31.6023 15.5565L31.4597 15.3426C28.6587 17.8685 25.9291 20.4352 23.6374 23.3889Z"
        fill="url(#paint3_linear_2483_1780)"
      />
      <path
        d="M29.6669 10.4537C25.8169 13.1222 21.0808 14.0898 16.8437 16.0861C15.9474 16.5139 15.0715 16.9824 14.2363 17.5019C14.3586 18.5204 14.7354 19.4981 15.3261 20.3333L16.3548 21.8L29.9928 12.2463C31.5613 11.1463 32.5493 9.39444 32.6613 7.47963C31.8465 8.64074 30.828 9.64907 29.6669 10.4537Z"
        fill="url(#paint4_linear_2483_1780)"
      />
      <path
        d="M32.6106 29.6528C29.4633 30.1926 26.3467 31.2213 23.9939 33.3296C21.0707 35.9472 19.7365 39.9093 19.6143 43.8306L30.1356 36.4565C32.3152 34.9185 33.293 32.2093 32.6106 29.6528Z"
        fill="url(#paint5_linear_2483_1780)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2483_1780"
          x1="14.1859"
          y1="11.9004"
          x2="32.676"
          y2="11.9004"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FB8D63" />
          <stop offset="1" stopColor="#FDA96C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2483_1780"
          x1="14.2606"
          y1="24.002"
          x2="32.7499"
          y2="24.002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEAD6D" />
          <stop offset="0.37" stopColor="#FEAD6D" />
          <stop offset="1" stopColor="#FEB26D" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2483_1780"
          x1="14.3356"
          y1="36.1026"
          x2="32.8257"
          y2="36.1026"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FDAC6B" />
          <stop offset="0.95" stopColor="#FDBD7C" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2483_1780"
          x1="27.1318"
          y1="27.4556"
          x2="22.9768"
          y2="20.258"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.15" stopColor="#FEBA7D" />
          <stop offset="0.76" stopColor="#FEBE7F" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2483_1780"
          x1="18.2706"
          y1="17.6544"
          x2="30.6517"
          y2="9.34535"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEB16E" />
          <stop offset="1" stopColor="#FFB76E" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2483_1780"
          x1="18.9014"
          y1="43.1055"
          x2="32.4839"
          y2="29.523"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FCA56C" />
          <stop offset="0.95" stopColor="#FEA368" />
        </linearGradient>
      </defs>
    </svg>
  )
}
